import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import finalIcon from "../../../../../assets/design-revamp-company/company-detail-headers/final-treatment-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import { getCompFinalTreatmentTotal } from "../../../../../apis/Business/CompanyFinalTreatmentTotalApi";

const FinalTreatmentIcon = () => (
  <img
    src={finalIcon}
    alt="Processing Intermediate Icon"
    width={76}
    height={76}
  />
);

const FinalTreatmentHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjProcessing, setTotalObjProcessing] = useState([]);
  const [systemBoundaryProcess, setSystemBoundaryProcess] = useState("");
  useEffect(() => {
    getCompFinalTreatmentTotal({
      businessId: businessId,
      setTotalObj: setTotalObjProcessing,
      setSystemBoundaryProcessing: setSystemBoundaryProcess,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`final-treatment-category ${className || ""}`}
      leftBoxProps={{
        icon: <FinalTreatmentIcon />,
        title: t("FINAL_TREATMENT_PRODUCTS"),
        description: t("COMP_FINAL_TREATMENT_DESC"),
        scopes: [{ scope: "Scope 3", filled: true }],
        isSystemBoundary: true,
        systemBoundary: systemBoundaryProcess,
        setSystemBoundary: setSystemBoundaryProcess,
        businessId: businessId,
        totalObjCategory: totalObjProcessing?.category_name,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjProcessing,
                      totalObjProcessing?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjProcessing,
                  totalObjProcessing?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjProcessing,
                      totalObjProcessing.total_scope_3_cat13
                    ),
                    scopes: ["S:3, C:13"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjProcessing,
                      totalObjProcessing.total_scope_3_cat12
                    ),
                    scopes: ["S:3, C:12"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjProcessing?.updated_at
          ? formatDate(totalObjProcessing?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default FinalTreatmentHeader;
